import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';

import { CollapseCheckbox } from '../components/collapseCheckbox';
import { JaNeiVetIkke, OppvarmingBruk, Varmesentral } from '../../../../../utils/registerEnums';
import { KjelVannbarenVarme } from '../components/kjelVannbarenVarme';
import { AboutFormControlProps } from '../../types';

const kaminDefaultValue = {
  serviceGjennomfortSiste2Ar: JaNeiVetIkke.VetIkke,
  varmesentral: Varmesentral.Ukjent,
  bruk: OppvarmingBruk.Ukjent
};

export const KaminVannbarenVarmeField: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();
  return (
    <Controller
      name="oppvarming.oppvarmingBioenergi.kaminMedVannbarenVarme.selected"
      control={control}
      render={({ field, fieldState }) => (
        <CollapseCheckbox
          labelKey="register.tekniskUtstyr.bioKaminMedVannbarenVarme.label"
          checked={!!field.value}
          onChange={(checked) => {
            field.onChange(checked);

            const newValue = checked ? kaminDefaultValue : undefined;

            setValue('oppvarming.oppvarmingBioenergi.kaminMedVannbarenVarme.value', newValue);
          }}
          error={!!fieldState.error}
        >
          <KjelVannbarenVarme name="oppvarming.oppvarmingBioenergi.kaminMedVannbarenVarme.value" control={control} />
        </CollapseCheckbox>
      )}
    />
  );
};
